import React, { useState, useEffect } from 'react';
import { Box, Skeleton } from '@mui/material';

interface ImageLoaderProps {
  src: string;
  alt: string;
}

const ImageLoader: React.FC<ImageLoaderProps> = ({ src, alt }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    // Reset states when src changes
    setLoading(true);
    setError(false);
  }, [src]);

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  return (
    <>
      {loading && (
        <Skeleton 
          variant="rectangular" 
          width="100%" 
          height={240}
          animation="wave"
        />
      )}
      
      <Box sx={{ 
        display: loading ? 'none' : 'block',
        textAlign: 'center'
      }}>
        {!error ? (
          <img 
            src={src} 
            alt={alt} 
            onLoad={handleLoad} 
            onError={handleError}
            style={{
              maxWidth: '100%',
              borderRadius: '4px',
              boxShadow: '0px 2px 8px rgba(0,0,0,0.1)'
            }}
          />
        ) : (
          <Box 
            sx={{ 
              p: 2, 
              bgcolor: 'background.default',
              border: '1px dashed grey.400',
              borderRadius: 1,
              color: 'text.secondary',
              fontSize: '0.875rem'
            }}
          >
            Error loading image: {alt || 'Image could not be loaded'}
          </Box>
        )}
        {alt && (
          <Box component="span" sx={{ 
            display: 'block',
            mt: 0.5,
            fontSize: '0.75rem',
            color: 'text.secondary'
          }}>
            {alt}
          </Box>
        )}
      </Box>
    </>
  );
};

export default ImageLoader;
